import React, {FC} from 'react';

import classNames from 'classnames';

import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';
import {CheckoutItemType} from 'desktop/types/checkoutItemsType';

import {CartItemQty} from '../cartItemQty/cartItemQty';

import RefreshCLSubscriptionIcon from './img/refreshIcon.svg?url';

import s from './cartItemInfo.scss';

export type PropsType = {
    item: CheckoutItemType;
};

/**
 * Cart Item Information
 * @constructor
 */
export const CartItemInfo: FC<PropsType> = ({item}) => {
    const isGlasses = !['accessories', 'contact_lenses'].includes(item.product.type);
    const isAccessories = item.product.type === 'accessories';
    const isCLSubscriptionEnabled = !isGlasses && item.subscription?.subscriptionMode;
    const contactLensesColor =
        item.product.type === 'contact_lenses' && item.prescription?.od?.color;

    return (
        <div className={classNames(s.productInfo, isAccessories && s.productInfoAccessories)}>
            <p className={s.info}>
                {isGlasses &&
                    `${item.product.color}${
                        item.product.size ? `, ${item.product.size.charAt(0).toUpperCase()}` : ''
                    } | `}
                {contactLensesColor && <span className={s.color}>{contactLensesColor} | </span>}
                <CartItemQty item={item} />
            </p>
            {isCLSubscriptionEnabled && (
                <div className={s.contactLensesSubscription}>
                    <CloudinaryImage
                        className={s.contactLensesSubscriptionIcon}
                        height={14}
                        src={RefreshCLSubscriptionIcon}
                        width={13}
                    />
                    Subscribed
                </div>
            )}
        </div>
    );
};
